import * as React from "react";
import { UitkLoader } from "uitk-react-loader";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";

interface LoaderProps {
  loading: boolean;
  className?: string;
}

export function Loader({ loading, className }: LoaderProps) {
  return loading ? (
    <UitkLayoutFlex className="loaderContainer" justifyContent="center" alignItems="center">
      <UitkLayoutFlexItem>
        <div>
          <UitkLoader className={className} />
        </div>
      </UitkLayoutFlexItem>
    </UitkLayoutFlex>
  ) : null;
}

export default Loader;
